import React, { useCallback, useMemo, useRef } from "react";
import { observer } from "mobx-react-lite";
import Button from "../../button/Button";
import { translationService } from "../../../services/translation/TranslationService";
import "./HighlightDetectedDamagesFilter.scss";
import { SegmentationService } from "../../../services/segmentation/SegmentationService";
import { FileStates } from "../../../services/shop/ShopHistoryStorage";

interface HighlightDetectedDamagesFilterProps {
  videoSegmentation?: SegmentationService;
}

export const HighlightDetectedDamagesFilter = observer(
  (props: HighlightDetectedDamagesFilterProps) => {
    const { videoSegmentation } = props;

    const buttonRef = useRef(null);
    const containerRef = useRef(null);

    const handleRetrySegmentation = useCallback(async () => {
      await videoSegmentation?.startService();
      await videoSegmentation?.load();
    }, [videoSegmentation])

    const filtersButtonText = useMemo(() => {
      const segmentationStatus = videoSegmentation?.status;

      if (segmentationStatus === FileStates.Running) {
        return "damages.highlight-detection.filter-on-video.running-hd";
      }

      if (segmentationStatus === FileStates.Failed) {
        return "damages.highlight-detection.filter-on-video.failed-hd";
      }

      return "";
    }, [videoSegmentation?.status]);

    console.log(videoSegmentation?.status)    
    return (
      <div ref={containerRef}>
        <Button
          id="filter-damages-button"
          ref={buttonRef}
          className={`filters-button ${FileStates[
            videoSegmentation?.status!
          ].toLowerCase()}`}
          onClick={handleRetrySegmentation}
          disabled={
            videoSegmentation?.status === FileStates.Running
          }
        >
          <div>{translationService.translate(filtersButtonText)}</div>
        </Button>
      </div>
    );
  }
);
